import { hasWorkException } from '@/utils/works-exceptions';
import type { SearchResultItem } from '../types';

export function shouldBlurSearchCover(item: SearchResultItem, hasConfirmedAge: boolean): boolean {
  if (item.type !== 'fanfic' || item.rating !== '18' || hasConfirmedAge) {
    return false;
  }

  return !hasWorkException(Number(item.id));
}
